/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgProjectAccounting = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7 2h10v2h4v5h-2V6h-2v2H7V6H5v14h7v2H3V4h4zm2 2v2h6V4zm8 8v-1h2v1h3v2h-3v2h1a3 3 0 1 1 0 6h-1v1h-2v-1h-3v-2h3v-2h-1a3 3 0 1 1 0-6zm0 2h-1a1 1 0 1 0 0 2h1zm2 4v2h1a1 1 0 1 0 0-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgProjectAccounting as ProjectAccounting };
